import { Injector } from '@angular/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { Node } from '@tiptap/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { parseJsonAttr } from '../parse-json-attr.util';
import { DEFAULT_GOJS_DIAGRAM_PROPS, GOJS_DIAGRAM_NODE_NAME } from './gojs-diagram.model';
import { GojsDiagramNodeComponent } from './gojs-diagram-node.component';

const GOJS_DIAGRAM_EXTENSION_NAME = GOJS_DIAGRAM_NODE_NAME;

export const GojsDiagramExtension = (injector: Injector) => {
  return Node.create({
    name: GOJS_DIAGRAM_EXTENSION_NAME,
    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        id: {
          default: '',
          renderHTML: (attributes) => ({ 'data-id': attributes['id'] }),
          parseHTML: (element) => element.getAttribute('data-id') ?? '',
        },
        model: {
          default: DEFAULT_GOJS_DIAGRAM_PROPS.model,
          renderHTML: (attributes) => ({ 'data-model': JSON.stringify(attributes['model']) }),
          parseHTML: (element) => parseJsonAttr(element, 'data-model', DEFAULT_GOJS_DIAGRAM_PROPS.model),
        },
        layout_type: {
          default: DEFAULT_GOJS_DIAGRAM_PROPS.layout_type,
          renderHTML: (attributes) =>
            attributes['layout_type'] ? { 'data-layout-type': attributes['layout_type'] } : {},
          parseHTML: (element) => element.getAttribute('data-layout-type') ?? 'tree',
        },
        height: {
          default: DEFAULT_GOJS_DIAGRAM_PROPS.height,
          renderHTML: (attributes) =>
            attributes['height'] !== null ? { 'data-height': String(attributes['height']) } : {},
          parseHTML: (element) => {
            const val = element.getAttribute('data-height');
            return val ? parseInt(val, 10) : null;
          },
        },
        custom_css: {
          default: '',
          renderHTML: (attributes) => (attributes['custom_css'] ? { 'data-custom-css': attributes['custom_css'] } : {}),
          parseHTML: (element) => element.getAttribute('data-custom-css') ?? '',
        },
        custom_style: {
          default: null,
          renderHTML: (attributes) =>
            attributes['custom_style'] ? { 'data-custom-style': JSON.stringify(attributes['custom_style']) } : {},
          parseHTML: (element) => parseJsonAttr(element, 'data-custom-style', null),
        },
        hover_highlight: {
          default: false,
          renderHTML: (attributes) => (attributes['hover_highlight'] ? { 'data-hover-highlight': 'true' } : {}),
          parseHTML: (element) => element.getAttribute('data-hover-highlight') === 'true',
        },
      };
    },

    parseHTML() {
      return [{ tag: 'div.gojs-diagram-block' }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', { class: 'gojs-diagram-block', ...HTMLAttributes }];
    },

    addNodeView() {
      return AngularNodeViewRenderer(GojsDiagramNodeComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
